export default __webpack_public_path__ + "static/media/background-1200.3ba597c3.jpeg";